'use strict';

CalendarResourceCtrl.$inject = ['$scope', '$element', 'mx.internationalization', 'mx.shell.HostUrlHelper'];

export default function CalendarResourceCtrl($scope, $element, i18n, hostUrlHelper) {
	var vm = this;
	vm.$onInit = function () {
		vm.resource = vm.calendar.resources.find(function (resource) {
			return resource.id === vm.resourceId;
		});

		vm.hasEntity = vm.resource.id && vm.resource.id !== 'unassigned';
		vm.photoCss = 'url("' + (hostUrlHelper.getFullImageUrl(vm.resource.image) || '') + '")';
		vm.hintContainer = $element.find('.mx-calendar-resource-header-cell__hint');

		$scope.$watch(
			function () {
				return vm.resource.eventsOfDay[vm.dayNumber];
			},
			function (numOfEvents) {
				var newHint = getHint(numOfEvents);
				if (vm.hint !== newHint) {
					vm.hint = newHint;
					//hint is rendered with 'text' function and not with a binding because of errors in IE
					vm.hintContainer.text(newHint);
				}
			}
		);
	};

	vm.zeroHint = i18n.get('solutionBuilderAgent.components.mx-calendar-resource.no-events-in-que');
	vm.oneHint = i18n.getFormatted('solutionBuilderAgent.components.mx-calendar-resource.event-in-que', 1);

	function getHint(numOfEvents) {
		switch (numOfEvents) {
			case 0:
			case undefined:
				return vm.zeroHint;
			case 1:
				return vm.oneHint;
			default:
				return i18n.getFormatted('solutionBuilderAgent.components.mx-calendar-resource.events-in-que', numOfEvents);
		}
	}
}
